let timeline = document.querySelector('.js-timeline');

if (typeof timeline != "undefined" && timeline != null) {
    timelineScroll();
}

function timelineScroll(){

    const timelineContent = document.querySelectorAll('.js-timeline-content'); 
    const timelineYear = document.querySelector('.js-timeline-year');
    
    //set the text content of the year as the first data att in the timeline
    timelineYear.textContent = timelineContent[0].dataset.year;

    //fade in the timeline year
    gsap.to(timelineYear, {
        delay: 1,
        autoAlpha: 1
    })

    if (ajaxOpen) {

        $ajaxOverlay.scroll(function(){
            //backup in case not enough content is put in to reach the scroll trigger point.
            if($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                timelineYear.textContent = timelineContent[timelineContent.length - 1].dataset.year;
            //set the year based on the data attribute of the element in the scroll trigger point.
            } else {
                timelineContent.forEach((content) => {
                    gsap.to(timelineYear, {
                        scrollTrigger: {
                            trigger: content,
                            start: "-200 bottom"
                        },
                        ease: "power4.out",
                        onUpdate: function () {
                            timelineYear.innerHTML = content.dataset.year;
                        }
                    });
                })
            }
        })
    } else {
        window.addEventListener('scroll', () => {
            //backup in case not enough content is put in to reach the scroll trigger point.
            if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight) {
                timelineYear.textContent = timelineContent[timelineContent.length - 1].dataset.year;
            //set the year based on the data attribute of the element in the scroll trigger point.
            } else {
                timelineContent.forEach((content) => {
                    gsap.to(timelineYear, {
                        scrollTrigger: {
                            trigger: content,
                            start: "-200 bottom"
                        },
                        ease: "power4.out",
                        onUpdate: function () {
                            timelineYear.innerHTML = content.dataset.year;
                        }
                    });
                })
            }
        })
    }
}

// ts should just be a case of checking whether the ajaxOpen js var is set to true, and if so you put the scroll listener on the overlay and not the window